import * as React from "react";

import {
    JobPriorityABadge,
    JobPriorityBBadge,
    JobPriorityCBadge,
    JobPriorityDBadge,
} from "../../assets/statusBadges";
import { Text } from "../../";
import { JobPriorityType } from "../../domain";

export interface JobPriorityLabelProps {
    jobPriority: number | JobPriorityType;
    id?: string;
    className?: string;
    title?: string;
}

export const JobPriorityLabel = (props: JobPriorityLabelProps) => {
    const { jobPriority, ...rest } = props;

    const status =
        jobPriority instanceof JobPriorityType
            ? jobPriority
            : JobPriorityType.fromId(jobPriority);
    switch (status) {
        case JobPriorityType.A:
            return <JobPriorityABadge {...rest} />;
        case JobPriorityType.B:
            return <JobPriorityBBadge {...rest} />;
        case JobPriorityType.C:
            return <JobPriorityCBadge {...rest} />;
        case JobPriorityType.D:
            return <JobPriorityDBadge {...rest} />;
        default:
            return <Text variant="body1">not selected</Text>;
    }
};
